import { render, staticRenderFns } from "./DeleteDistrict.vue?vue&type=template&id=4e4908b6&"
import script from "./DeleteDistrict.vue?vue&type=script&lang=ts&"
export * from "./DeleteDistrict.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports